// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"12309f7c","732":"54f39227"}[chunkId] + ".chunk.js";
};